import * as React from 'react';
import classnames from 'classnames';

import { FormField } from 'components/form';
import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';
import RadioButtons from 'components/inputs/radio-buttons/RadioButtons';
import AdminMultiSelect from '../../AdminMultiSelect';
import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';

import { isDefined } from 'utils/helper/common';
import { __t, applyTranslations } from 'utils/language';

import type { SelectionQuery } from '../sentiment-analysis-filters/SentimentAnalysisFilters';
import { MultiSelectItem, TextEntry } from 'types';

import './sentiment-analysis-secondary-filter.scss';

applyTranslations(require('./sentiment-analysis-secondary-filter.i18n.json'));
applyTranslations(require('components/sentiment-select/sentiment-select.i18n.json'));

type Props = {
  selection: SelectionQuery,
  taskSelectDisabled: boolean,
  tasksItems: Array<MultiSelectItem>,
  isNotFullscreen?: boolean,
  onFilterChange: (event: React.SyntheticEvent<TextEntry>) => void,
  onTaskTypeChange: (value: string) => void,
  onSelectChange: (value?: string | null, name?: string | null) => void
}

const SENTIMENT_FILTER_OPTIONS = ['positive', 'neutral', 'negative'];

function getTaskTypeOptions() {
  return [
    {
      name: 'All',
      value: 'all'
    },
    {
      name: 'IG Post',
      value: 'instagram_post'
    },
    {
      name: 'IG Reel',
      value: 'instagram_reel'
    },
    {
      name: 'TT Video',
      value: 'tiktok_video'
    }
  ].filter(isDefined);
}

const SentimentAnalysisSecondaryFilter = ({
  selection,
  tasksItems,
  taskSelectDisabled,
  isNotFullscreen,
  onFilterChange,
  onTaskTypeChange,
  onSelectChange
}: Props) => {
  const containerClass = classnames('sentiment-analysis-secondary-filters__filters', {
    'sentiment-analysis-secondary-filters__filters--small-screen': isNotFullscreen
  });

  return (
    <div className={containerClass}>
      <div className="sentiment-analysis-secondary-filters__top-container">
        <div className="sentiment-analysis-secondary-filters__filter-part sentiment-analysis-secondary-filters__filter-part-task-type">
          <FormField
            direction="column"
            inline
            showRequiredMark={false}
            showValidationIcon={false}
            label={__t('sentiment_analysis_secondary_filter.filter_by_task_type')}
            labelType="highlighted"
          >
            <RadioButtons
              selected={selection.taskTypes}
              direction="row"
              options={getTaskTypeOptions()}
              onChange={onTaskTypeChange}
            />
          </FormField>
        </div>
        <div className="sentiment-analysis-secondary-filters__filter-part sentiment-analysis-secondary-filters__filter-part--sentiment">
          <FormField
            direction="column"
            inline
            showRequiredMark={false}
            showValidationIcon={false}
            label={__t('sentiment_analysis_secondary_filter.filter_by_sentiment')}
            labelType="highlighted"
          >
            {
              SENTIMENT_FILTER_OPTIONS.map((option) => (
                <InputCheckbox
                  key={`sentiment-class-${option}`}
                  id={`sentiment-class-${option}`}
                  name="sentimentClass"
                  value={option}
                  size="small"
                  containerClass="sentiment-analysis-secondary-filters__checkbox"
                  label={__t(`sentiment_select.${option}`)}
                  checked={selection.sentimentClass.includes(option)}
                  onChange={onFilterChange}
                />
              ))
            }
          </FormField>
        </div>
      </div>
      <VerticalSpacing type="large" />
      <div className="sentiment-analysis-secondary-filters__filter-part sentiment-analysis-secondary-filters__filter-task-selector">
        <FormField
          direction="column"
          showRequiredMark={false}
          showValidationIcon={false}
          label={__t('sentiment_analysis_secondary_filter.search_by_task')}
          labelType="highlighted"
        >
          <AdminMultiSelect
            name="deliverableId"
            placeholder={__t('sentiment_analysis_secondary_filter.search_by_task_placeholder')}
            items={tasksItems}
            value={selection.deliverableId}
            disabled={taskSelectDisabled}
            onChange={onSelectChange}
          />
        </FormField>
      </div>
    </div>
  );
};

export default SentimentAnalysisSecondaryFilter;
